import hb1 from "../../img/brands/hugo boss/hb1.jpg";
import hb2 from "../../img/brands/hugo boss/hb2.jpg";
import hb3 from "../../img/brands/hugo boss/hb3.jpg";
import hb4 from "../../img/brands/hugo boss/hb4.jpg";
import hb5 from "../../img/brands/hugo boss/hb5.jpg";
import hb6 from "../../img/brands/hugo boss/hb6.jpg";
import hb7 from "../../img/brands/hugo boss/hb7.jpg";
import hb8 from "../../img/brands/hugo boss/hb8.jpg";
import hb9 from "../../img/brands/hugo boss/hb9.jpg";
import hb10 from "../../img/brands/hugo boss/hb10.jpg";
import hbBrandLogo from "../../img/brands/hugo boss/brand-logo.png";

import mb1 from "../../img/brands/mont blanc/mb1.jpg";
import mb2 from "../../img/brands/mont blanc/mb2.jpg";
import mb3 from "../../img/brands/mont blanc/mb3.jpg";
import mb4 from "../../img/brands/mont blanc/mb4.jpg";
import mb5 from "../../img/brands/mont blanc/mb5.jpg";
import mb6 from "../../img/brands/mont blanc/mb6.jpg";
import mb7 from "../../img/brands/mont blanc/mb7.jpg";
import mb8 from "../../img/brands/mont blanc/mb8.jpg";
import mb9 from "../../img/brands/mont blanc/mb9.jpg";
import mb10 from "../../img/brands/mont blanc/mb10.jpg";
import mbBrandLogo from "../../img/brands/mont blanc/brand-logo.png";

import dg1 from "../../img/brands/dg/dg1.jpg";
import dg2 from "../../img/brands/dg/dg2.jpg";
import dg3 from "../../img/brands/dg/dg3.jpg";
import dg4 from "../../img/brands/dg/dg4.jpg";
import dg5 from "../../img/brands/dg/dg5.jpg";
import dg6 from "../../img/brands/dg/dg6.jpg";
import dg7 from "../../img/brands/dg/dg7.jpg";
import dg8 from "../../img/brands/dg/dg8.jpg";
import dg9 from "../../img/brands/dg/dg9.jpg";
import dg10 from "../../img/brands/dg/dg10.jpg";
import dgBrandLogo from "../../img/brands/dg/brand-logo.png";

import pr1 from "../../img/brands/prada/pr1.jpg";
import pr2 from "../../img/brands/prada/pr2.jpg";
import pr3 from "../../img/brands/prada/pr3.jpg";
import pr4 from "../../img/brands/prada/pr4.jpg";
import pr5 from "../../img/brands/prada/pr5.jpg";
import pr6 from "../../img/brands/prada/pr6.jpg";
import pr7 from "../../img/brands/prada/pr7.jpg";
import pr8 from "../../img/brands/prada/pr8.jpg";
import pr9 from "../../img/brands/prada/pr9.jpg";
import pr10 from "../../img/brands/prada/pr10.jpg";
import prBrandLogo from "../../img/brands/prada/brand-logo.png";

import tf1 from "../../img/brands/tom ford/tf1.jpg";
import tf2 from "../../img/brands/tom ford/tf2.jpg";
import tf3 from "../../img/brands/tom ford/tf3.jpg";
import tf4 from "../../img/brands/tom ford/tf4.jpg";
import tf5 from "../../img/brands/tom ford/tf5.jpg";
import tf6 from "../../img/brands/tom ford/tf6.jpg";
import tf7 from "../../img/brands/tom ford/tf7.jpg";
import tf8 from "../../img/brands/tom ford/tf8.jpg";
import tf9 from "../../img/brands/tom ford/tf9.jpg";
import tf10 from "../../img/brands/tom ford/tf10.jpg";
import tfBrandLogo from "../../img/brands/tom ford/brand-logo.png";

import th1 from "../../img/brands/tommy hilfiger/th1.jpg";
import th2 from "../../img/brands/tommy hilfiger/th2.jpg";
import th3 from "../../img/brands/tommy hilfiger/th3.jpg";
import th4 from "../../img/brands/tommy hilfiger/th4.jpg";
import th5 from "../../img/brands/tommy hilfiger/th5.jpg";
import th6 from "../../img/brands/tommy hilfiger/th6.jpg";
import th7 from "../../img/brands/tommy hilfiger/th7.jpg";
import th8 from "../../img/brands/tommy hilfiger/th8.jpg";
import th9 from "../../img/brands/tommy hilfiger/th9.jpg";
import th10 from "../../img/brands/tommy hilfiger/th10.jpg";
import thBrandLogo from "../../img/brands/tommy hilfiger/brand-logo.png";

import fs1 from "../../img/brands/fastrack/fs1.jpg";
import fs2 from "../../img/brands/fastrack/fs2.jpg";
import fs3 from "../../img/brands/fastrack/fs3.jpg";
import fs4 from "../../img/brands/fastrack/fs4.jpg";
import fs5 from "../../img/brands/fastrack/fs5.jpg";
import fs6 from "../../img/brands/fastrack/fs6.jpg";
import fs7 from "../../img/brands/fastrack/fs7.jpg";
import fs8 from "../../img/brands/fastrack/fs8.jpg";
import fs9 from "../../img/brands/fastrack/fs9.jpg";
import fs10 from "../../img/brands/fastrack/fs10.jpg";
import fsBrandLogo from "../../img/brands/fastrack/brand-logo.png";

const hugoBoss = {
  hbBrandLogo,
  hb1,
  hb2,
  hb3,
  hb4,
  hb5,
  hb6,
  hb7,
  hb8,
  hb9,
  hb10,
};
const montBlanc = {
  mbBrandLogo,
  mb1,
  mb2,
  mb3,
  mb4,
  mb5,
  mb6,
  mb7,
  mb8,
  mb9,
  mb10,
};
const dg = { dgBrandLogo, dg1, dg2, dg3, dg4, dg5, dg6, dg7, dg8, dg9, dg10 };
const prada = {
  prBrandLogo,
  pr1,
  pr2,
  pr3,
  pr4,
  pr5,
  pr6,
  pr7,
  pr8,
  pr9,
  pr10,
};
const tomFord = {
  tfBrandLogo,
  tf1,
  tf2,
  tf3,
  tf4,
  tf5,
  tf6,
  tf7,
  tf8,
  tf9,
  tf10,
};

const tommyH = {
  thBrandLogo,
  th1,
  th2,
  th3,
  th4,
  th5,
  th6,
  th7,
  th8,
  th9,
  th10,
};

const fastrack = {
  fsBrandLogo,
  fs1,
  fs2,
  fs3,
  fs4,
  fs5,
  fs6,
  fs7,
  fs8,
  fs9,
  fs10,
};

export { hugoBoss, montBlanc, dg, prada, tomFord, tommyH, fastrack };
